export default "__VITE_ASSET__BIZXaQgE__"